import axios from "axios";
import tip from "@/utils/tip";
import ErrorHandler from "./error";
import { baseUrl } from "@/config/url";
import i18n from "@/lang";

let instance = axios.create({
  baseURL: baseUrl(),
  // withCredentials: false,
});

// 設定Content-Type
instance.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

// 設定全域請求回應中繼
instance.interceptors.response.use(
  (response) => {
    // 從axios的回應結構取回api結果
    let result = typeof response === "object" ? response.data : {};

    if ("retcode" in result) {
      if (result.retcode < 0) {
        return ErrorHandler.parse(result);
      } else {
        return result;
      }
    } else {
      return Promise.reject(i18n.t("statusCode['-5']")+"[29]");
    }
  },
  (error) => {
    const { response } = error;

    if (response) {
      if (response.status) {
        if (response.status == '504') {
          tip.error({showClose: true, duration: 0, message: response.status + " " + response.statusText});
          return {retcode: 0, data: []}
        } else {
          tip.error(response.status + " " + response.statusText);
        }
      } else {
        tip.error(error.message);
      }
    } else {
      if (!window.navigator.onLine) {
        tip.warning(i18n.t("statusCode[998]"));
      }
    }

    return Promise.reject(error);
  }
);

export default {
  _instance: instance,
  post: (url, data = null, config = null) => {
    return instance.post(
      url,
      { ...data, app_version: process.env.VUE_APP_VERSION },
      config
    );
  },
  get: (url, params = null) => {
    return instance.get(url, { params });
  },
};
